<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      :class="{
        'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <template v-if="data">
        <BreadCrumbFromRoute
          :class="{
            'hero-container': true,
          }"
          :title="data.title"
        />

        <BlogHero :blog-hero="data.blogHero" />

        <PortableText
          v-if="data.content.blogPortableText"
          :class="{
            'p-0 text-www-color-neutral-medium-dark': true,
          }"
          :portable-data="data?.content.blogPortableText"
        />

        <CTABanner
          v-if="data.CTABanner?.reference"
          :data="data.CTABanner.reference"
        />

        <SuggestedContent
          v-if="!data.removeSuggestedContent"
          :suggested-title="data.suggestedContentTitle"
        />
      </template>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryWhatIsNew } from '~/queries/pages/PageWhatIsNew.query';
import type { QueryWhatIsNewResult } from '~/sanity/types';
import BreadCrumbFromRoute from '~/components/Atmos/BreadCrumb/BreadCrumbFromRoute.vue';
import BlogHero from '~/components/Organisms/BlogHero/BlogHero.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import SuggestedContent from '~/components/Organisms/SuggestedContent/SuggestedContent.vue';
import { extractAbstractFromPortableText } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryWhatIsNewResult>(queryWhatIsNew, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  author: data.value?.blogHero.person?.reference?.name,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  title: data.value?.htmlTitle || data.value?.title,
  structuredData: [
    {
      schemaType: 'NewsArticle',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      contentSummary: data.value?.description,
      abstract: extractAbstractFromPortableText(data.value?.content?.blogPortableText),
      imageRef: data.value?.ogImage?.asset?._ref || data.value?.cardImage?.asset?._ref,
      authorName: data.value?.blogHero.person?.reference?.name,
      dateModified: data.value?._updatedAt,
      datePublished: data.value?.articleDate,
      articleSection: data.value?.blogHero.taxonomies?.[0]?.prefLabel,
      keywords: data.value?.blogHero.taxonomies?.map((taxonomy) => taxonomy.prefLabel),
      enabled: true,
    },
  ],
});
</script>
